import apiClient from "./ApiClient"

export default {
  getProducts() {
    return apiClient.get('/products')
  },
  getProductsCategories(category_slug) {
    return apiClient.get('/products/?category_name=' + category_slug)
  },
  getProduct(product_slug){
    console.log(product_slug)
    return apiClient.get('/product?slug=' + product_slug)
  },
  getProductById(product_id){
    return apiClient.get('/product_by_id?product_id=' + product_id)
  },
  searchProduct(term){
    return apiClient.get('/search?term=' + term)
  },
  searchMultiple(terms) {
    let data = {
      terms: terms,
      limit: 10,
      offset: 0
    };
    return apiClient.post('/search_multiple', data)
  },
  getAppVersion() {
    return apiClient.get('/appversion')
  }
}
